import { Alert, Collapse, FormSection, List } from '@ksyos/design-system';
import { useState } from 'react';
import { getSelectedLanguage } from '@frontend/translate';

type ContraIndicationsAlertProps = {
    absoluteContraIndications: string;
    absoluteContraIndicationsTitle: string;
    disclaimer: string;
    relativeContradictions: string;
    relativeContradictionsTitle: string;
    subtitle: string;
    title: string;
};

export function ContraIndicationsAlert(props: Readonly<ContraIndicationsAlertProps>) {
    const {
        absoluteContraIndications,
        absoluteContraIndicationsTitle,
        disclaimer,
        relativeContradictions,
        relativeContradictionsTitle,
        subtitle,
        title,
    } = props;
    const [isRelativeContraIndicationsOpen, setIsRelativeContraIndicationsOpen] = useState(false);

    const translate = getSelectedLanguage();

    return (
        <FormSection>
            <Alert appearance="info">
                <Alert.Text
                    fontWeight="medium"
                    mb={4}
                >
                    {title}
                </Alert.Text>
                <Alert.Text
                    fontStyle="italic"
                    mb={4}
                    mt={4}
                    size="sm"
                >
                    {subtitle}
                </Alert.Text>
                {renderList(absoluteContraIndicationsTitle, String(absoluteContraIndications).split(','))}
                <Collapse isOpen={isRelativeContraIndicationsOpen}>
                    {renderList(relativeContradictionsTitle, String(relativeContradictions).split(','))}
                    <Alert.Text
                        fontStyle="italic"
                        mb={4}
                        mt={4}
                        size="sm"
                    >
                        {disclaimer}
                    </Alert.Text>
                </Collapse>
                <Alert.Link
                    fontWeight="normal"
                    iconLeft={isRelativeContraIndicationsOpen ? 'caret-up' : 'caret-down'}
                    mt={2}
                    onClick={() => setIsRelativeContraIndicationsOpen(!isRelativeContraIndicationsOpen)}
                    size="sm"
                    variant="button"
                >
                    {isRelativeContraIndicationsOpen
                        ? translate.allergology.contraIndications.toggleContraIndicationsClose
                        : translate.allergology.contraIndications.toggleContraIndicationsOpen}
                </Alert.Link>
            </Alert>
        </FormSection>
    );

    function renderList(title: string, items: string[]) {
        return (
            <>
                <Alert.Text fontWeight="medium">{title}</Alert.Text>
                <List
                    size="small"
                    styleType="bullet"
                    sx={{
                        mb: 4,
                        ml: 2,
                    }}
                >
                    {items.map((item) => (
                        <List.Item key={item}>{item}</List.Item>
                    ))}
                </List>
            </>
        );
    }
}
